type ThemeChoice = `system` | `light` | `dark`;

const storageKey = `regvarme-theme`;

const savedChoice = (): ThemeChoice => {
    try {
        const value = localStorage.getItem(storageKey);
        return value === `light` || value === `dark` ? value : `system`;
    }
    catch (_error) {
        return `system`;
    }
};

const setChoice = (choice: ThemeChoice) => {
    if (choice === `system`) {
        document.documentElement.removeAttribute(`data-theme`);
    }
    else {
        document.documentElement.dataset.theme = choice;
    }
    for (const select of document.querySelectorAll<HTMLSelectElement>(`.theme-control select`)) {
        select.value = choice;
    }
    try {
        if (choice === `system`) localStorage.removeItem(storageKey);
        else localStorage.setItem(storageKey, choice);
    }
    catch (_error) {
        // The choice still applies to this page when storage is unavailable.
    }
};

export const createThemeControl = (id: string): HTMLElement => {
    const control = document.createElement(`div`);
    control.className = `theme-control`;
    const label = document.createElement(`label`);
    label.htmlFor = id;
    label.textContent = `Utseende`;
    const select = document.createElement(`select`);
    select.id = id;
    select.className = `form-select form-select-sm`;
    const choices: { value: ThemeChoice; label: string }[] = [
        { value: `system`, label: `System` },
        { value: `light`, label: `Lyst` },
        { value: `dark`, label: `Mørkt` }
    ];
    choices.forEach(choice => {
        const option = document.createElement(`option`);
        option.value = choice.value;
        option.textContent = choice.label;
        select.append(option);
    });
    select.value = savedChoice();
    setChoice(select.value as ThemeChoice);
    select.addEventListener(`change`, () => setChoice(select.value as ThemeChoice));
    control.append(label, select);
    return control;
};
